/** @format */

import { Button } from '@/components/ui/button';
import { cn } from '@/lib';
import { setLoginPopup } from '@/redux/actions/common.action';
import { AppDispatch } from '@/redux/store';
import { ErrorMessage, Field, Formik } from 'formik';
import { Loader2 } from 'lucide-react';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import { usePhoneNumber } from './hook';

const StepMobile = ({ isCuriobit, onNext, updateState, state }: any) => {
  const { initialValues, phoneValidationSchema, handleSubmit, loading } =
    usePhoneNumber({ onNext, updateState, state });
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div className='h-fit flex flex-col gap-6 px-6 pb-6'>
      <div>
        <p className='text-center text-base font-bold'>
          Enter your phone number
        </p>
        <p className='text-center text-xs font-semibold text-zinc-500'>
          If you don’t have an account yet, we’ll create one for you.
        </p>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={phoneValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit, errors, touched }) => {
          return (
            <>
              <div>
                <div className={cn('border flex items-center rounded-md text-xs font-semibold px-2 tracking-wider', (errors.phone && touched.phone) && 'border-red-600')}>
                  <p>+91</p>

                  <Field
                    name={'phone'}
                    placeholder='Enter phone number'
                    className='py-3 px-2 *:bg-none text-xs! border-none flex-1 tracking-wider focus:outline-none focus:ring-0 focus:border-transparent rounded-lg'
                    type={'tel'}
                    maxLength={10}
                  />

                </div>
                <ErrorMessage
                  component='p'
                  className='pt-1 text-xs text-red-600'
                  name='phone'
                />
              </div>
              <Button
                className={cn('w-full rounded-lg p-5', isCuriobit ? "text-black bg-gradient-to-r from-yellow-400 via-amber-500 to-orange-500 " : "bg-primary text-white")}
                onClick={() => handleSubmit()}
                disabled={loading}
                type='submit'
              >
                {loading ? <Loader2 className='animate-spin' /> : 'Continue'}
              </Button>
              <p className='text-center text-[11px] tracking-wide font-semibold text-zinc-500'>
                By continuing, you agree to our{' '}
                <Link href='/terms-and-conditions' onClick={() => dispatch(setLoginPopup(false))} className='text-zinc-900 hover:underline'>
                  Terms of Service
                </Link>{' '}
                & {' '}
                <Link href='/privacy-policy' onClick={() => dispatch(setLoginPopup(false))} className='text-zinc-900 hover:underline'>
                  Privacy Policy
                </Link>{' '}
              </p>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default StepMobile;
